import { render, staticRenderFns } from "./assets.vue?vue&type=template&id=1df4c95e&"
import script from "./assets.vue?vue&type=script&lang=ts&"
export * from "./assets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports